export default "/assets/website/images/2018-19.jpeg?6bd8d0599d32cc31409d569db0ee528e";